import { render, staticRenderFns } from "./MutualFundWrapper.vue?vue&type=template&id=891ecddc&scoped=true&"
import script from "./MutualFundWrapper.vue?vue&type=script&lang=js&"
export * from "./MutualFundWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MutualFundWrapper.vue?vue&type=style&index=0&id=891ecddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891ecddc",
  null
  
)

export default component.exports